export default __webpack_public_path__ + "static/media/graignes14.fbe0031d.jpg";